import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Alert = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Alert' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,17 L12,19 M12,10 L12,16 M12,3 L2,22 L22,22 L12,3 Z' />
  </StyledIcon>
);
